import { PriceWithDiscount, type MonthlyPriceWithDiscountProps } from "@/components/PriceWithDiscount.tsx";
import { Trans } from "@lingui/react/macro";
import type { VirtualMachineStorageReplica } from "@warrenio/api-spec/spec.oats.gen";

export function ReplicaPrice({
    type,
    ...priceProps
}: {
    type: VirtualMachineStorageReplica["type"];
} & Omit<MonthlyPriceWithDiscountProps, "allowFree">) {
    const priceWithDiscount = <PriceWithDiscount allowFree={false} {...priceProps} />;
    return {
        backup: <Trans>Estimated price per backup is {priceWithDiscount} per month.</Trans>,
        snapshot: <Trans>Estimated price per snapshot is {priceWithDiscount} per month.</Trans>,
    }[type];
}
